import CommonCells from './component';

export default CommonCells;
